// Campus photo for /colleges/university-of-tulsa: CC BY 4.0, by G. Edward Johnson, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMcFarlin_Library_front_University_of_Tulsa_OK_2026-05-23_19-43-21.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-tulsa/; credited under the photo.
const photo = {
    "slug": "university-of-tulsa",
    "alt": "The front of McFarlin Library, a Collegiate Gothic building with a central tower, at the University of Tulsa in Oklahoma",
    "src": "/colleges/university-of-tulsa/campus-1600.webp",
    "srcSmall": "/colleges/university-of-tulsa/campus-800.webp",
    "srcMid": "/colleges/university-of-tulsa/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-tulsa/og.jpg",
    "title": "McFarlin Library front University of Tulsa OK 2026-05-23 19-43-21",
    "author": "G. Edward Johnson",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMcFarlin_Library_front_University_of_Tulsa_OK_2026-05-23_19-43-21.jpg",
    "read": "2026-10-02"
};

export default photo;
